import { Navigate, Outlet } from "react-router";
import { hasToken } from "../lib/auth";

/** ต้องมี token ใน localStorage ก่อนเข้าหน้าใน shell — ไม่มีให้ไป /login */
export function RequireAuth() {
  if (!hasToken()) return <Navigate to="/login" replace />;
  return <Outlet />;
}
